<template>
  <el-dialog
    class="member-redeem-result-dialog"
    :visible="visible"
    :before-close="handleClose"
    append-to-body
  >
    <div class="redeem-result">
      <img
        class="redeem-result__icon"
        :src="resultConfig.icon"
        alt=""
      />
      <strong class="redeem-result__title">{{ resultConfig.title }}</strong>
      <p class="redeem-result__description">{{ resultDescription }}</p>
      <div class="redeem-result__actions">
        <button
          v-if="status === 'SUCCESS'"
          type="button"
          class="redeem-result__button is-secondary"
          @click="handleViewHistory"
        >
          查看订单记录
        </button>
        <button
          type="button"
          class="redeem-result__button is-primary"
          @click="handleClose"
        >
          我知道了
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
const RESULT_CONFIG = {
  SUCCESS: {
    icon: require("@/assets/imgs/payment/redeem-success-icon.png"),
    title: "兑换成功",
    description: "您已成功兑换个人会员，在订单记录中即可查看。",
  },
  EXPIRED: {
    icon: require("@/assets/imgs/payment/redeem-expired-icon.png"),
    title: "兑换码已过期",
    description: "抱歉，您的兑换码已过有效期，无法完成兑换。",
  },
  USED: {
    icon: require("@/assets/imgs/payment/redeem-disable-icon.png"),
    title: "兑换码已使用",
    description: "抱歉，此兑换码已完成兑换，无法重复使用。",
  },
  DISABLED: {
    icon: require("@/assets/imgs/payment/redeem-invalid-icon.png"),
    title: "兑换码无效",
    description: "抱歉，未查询到该兑换码，请确认号码是否输入正确。",
  },
};

export default {
  name: "MemberRedeemResultDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: "DISABLED",
    },
    message: {
      type: String,
      default: "",
    },
  },
  computed: {
    resultConfig() {
      return RESULT_CONFIG[this.status] || RESULT_CONFIG.DISABLED;
    },
    resultDescription() {
      return this.message || this.resultConfig.description;
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleViewHistory() {
      this.$emit("update:visible", false);
      this.$emit("view-history");
    },
  },
};
</script>

<style lang="less" scoped>
.member-redeem-result-dialog {
  /deep/ .el-dialog {
    width: 340px;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    border-radius: 12px;
    transform: translate(-50%, -50%);
    box-shadow: 0 18px 52px rgba(22, 41, 78, 0.2);
  }
  /deep/ .el-dialog__header {
    padding: 0;
  }
  /deep/ .el-dialog__headerbtn {
    top: 18px;
    right: 18px;
    .el-dialog__close {
      color: #7f8794;
      font-size: 18px;
    }
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
}

.redeem-result {
  min-height: 360px;
  padding: 36px 24px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.redeem-result__icon {
  width: 92px;
  height: 92px;
  object-fit: contain;
}
.redeem-result__title {
  margin-top: 26px;
  color: #333333;
  font-size: 18px;
  line-height: 25px;
}
.redeem-result__description {
  width: 100%;
  min-height: 44px;
  margin: 20px 0 24px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
}
.redeem-result__actions {
  width: 100%;
  margin-top: auto;
  display: flex;
  justify-content: center;
  gap: 12px;
}
.redeem-result__button {
  min-width: 100px;
  height: 38px;
  padding: 0 18px;
  border-radius: 8px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  &.is-primary {
    border: 1px solid #087bfa;
    background: #087bfa;
    color: #fff;
  }
  &.is-secondary {
    border: 1px solid #d8dce3;
    background: #fff;
    color: #697182;
  }
}
</style>
